function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return generator._invoke = function (innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; }(innerFn, self, context), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; this._invoke = function (method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) { if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; } return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (object) { var keys = []; for (var key in object) { keys.push(key); } return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) { "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); } }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

import React, { useRef, useCallback, useMemo } from 'react';
import { Transition } from 'react-transition-group';
import { classNames } from '../../utilities/css.js';
import { useEventListener } from '../../utilities/use-event-listener.js';
import { useToggle } from '../../utilities/use-toggle.js';
import { useOnValueChange } from '../../utilities/use-on-value-change.js';
import { useBreakpoints } from '../../utilities/breakpoints.js';
import { IndexFiltersMode } from './types.js';
import styles from './IndexFilters.scss.js';
import { useIsSticky } from './hooks/useIsSticky/useIsSticky.js';
import { UpdateButtons } from './components/UpdateButtons/UpdateButtons.js';
import { SortButton } from './components/SortButton/SortButton.js';
import { Container } from './components/Container/Container.js';
import { AlphaTabs } from '../AlphaTabs/AlphaTabs.js';
import { SearchFilterButton } from './components/SearchFilterButton/SearchFilterButton.js';
import { AlphaFilters } from '../AlphaFilters/AlphaFilters.js';
import { useI18n } from '../../utilities/i18n/hooks.js';
import { HorizontalStack } from '../HorizontalStack/HorizontalStack.js';
import { Spinner } from '../Spinner/Spinner.js';
var DEFAULT_IGNORED_TAGS = ['INPUT', 'SELECT', 'TEXTAREA'];
var TRANSITION_DURATION = 150;
var defaultStyle = {
  transition: "opacity ".concat(TRANSITION_DURATION, "ms var(--p-motion-ease)"),
  opacity: 0
};
var transitionStyles = {
  entering: {
    opacity: 1
  },
  entered: {
    opacity: 1
  },
  exiting: {
    opacity: 0
  },
  exited: {
    opacity: 0
  },
  unmounted: {
    opacity: 0
  }
};

function IndexFilters(_ref) {
  var tabs = _ref.tabs,
      selected = _ref.selected,
      onSelect = _ref.onSelect,
      onSort = _ref.onSort,
      onSortKeyChange = _ref.onSortKeyChange,
      onSortDirectionChange = _ref.onSortDirectionChange,
      sortOptions = _ref.sortOptions,
      sortSelected = _ref.sortSelected,
      _ref$queryValue = _ref.queryValue,
      queryValue = _ref$queryValue === void 0 ? '' : _ref$queryValue,
      queryPlaceholder = _ref.queryPlaceholder,
      primaryAction = _ref.primaryAction,
      cancelAction = _ref.cancelAction,
      filters = _ref.filters,
      appliedFilters = _ref.appliedFilters,
      onClearAll = _ref.onClearAll,
      onQueryChange = _ref.onQueryChange,
      onQueryFocus = _ref.onQueryFocus,
      onQueryClear = _ref.onQueryClear,
      onEditStart = _ref.onEditStart,
      disabled = _ref.disabled,
      disableQueryField = _ref.disableQueryField,
      hideFilters = _ref.hideFilters,
      loading = _ref.loading,
      mode = _ref.mode,
      setMode = _ref.setMode,
      disableStickyMode = _ref.disableStickyMode,
      _ref$isFlushWhenStick = _ref.isFlushWhenSticky,
      isFlushWhenSticky = _ref$isFlushWhenStick === void 0 ? false : _ref$isFlushWhenStick,
      _ref$canCreateNewView = _ref.canCreateNewView,
      canCreateNewView = _ref$canCreateNewView === void 0 ? true : _ref$canCreateNewView,
      onCreateNewView = _ref.onCreateNewView,
      filteringAccessibilityLabel = _ref.filteringAccessibilityLabel,
      filteringAccessibilityTooltip = _ref.filteringAccessibilityTooltip,
      hideQueryField = _ref.hideQueryField;
  var i18n = useI18n();

  var _useBreakpoints = useBreakpoints(),
      mdDown = _useBreakpoints.mdDown;

  var defaultRef = useRef(null);
  var filteringRef = useRef(null);

  var _useToggle = useToggle(false),
      filtersFocused = _useToggle.value,
      setFiltersUnFocused = _useToggle.setFalse,
      setFiltersFocused = _useToggle.setTrue;

  useOnValueChange(mode, function (newMode) {
    if (newMode === IndexFiltersMode.Filtering) {
      setFiltersFocused();
    } else {
      setFiltersUnFocused();
    }
  });
  useEventListener('keydown', function (event) {
    var _document, _document$activeEleme;

    var key = event.key;
    var tag = (_document = document) === null || _document === void 0 ? void 0 : (_document$activeEleme = _document.activeElement) === null || _document$activeEleme === void 0 ? void 0 : _document$activeEleme.tagName;

    if (mode !== IndexFiltersMode.Default && event.key === 'Escape') {
      onPressEscape();
    }

    if (key === 'f' && mode === IndexFiltersMode.Default) {
      if (tag && DEFAULT_IGNORED_TAGS.includes(tag)) {
        return;
      }

      onPressF();
      event.preventDefault();
    }
  });

  var _useIsSticky = useIsSticky(mode, Boolean(disableStickyMode), isFlushWhenSticky),
      intersectionRef = _useIsSticky.intersectionRef,
      measurerRef = _useIsSticky.measurerRef,
      indexFilteringHeight = _useIsSticky.indexFilteringHeight,
      isSticky = _useIsSticky.isSticky;

  var viewNames = tabs.map(function (_ref2) {
    var content = _ref2.content;
    return content;
  });
  var handleChangeSortButton = useCallback(function (value) {
    onSort === null || onSort === void 0 ? void 0 : onSort(value);
  }, [onSort]);
  var handleChangeSearch = useCallback(function (value) {
    onQueryChange(value);
  }, [onQueryChange]);

  var useExecutedCallback = function useExecutedCallback(action, afterEffect) {
    return useCallback( /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(name) {
        var hasExecuted;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return action === null || action === void 0 ? void 0 : action(name);

              case 2:
                hasExecuted = _context.sent;

                if (hasExecuted) {
                  setMode(IndexFiltersMode.Default);
                  afterEffect === null || afterEffect === void 0 ? void 0 : afterEffect();
                }

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x) {
        return _ref3.apply(this, arguments);
      };
    }(), [action, afterEffect]);
  };

  var onExecutedPrimaryAction = useExecutedCallback(primaryAction === null || primaryAction === void 0 ? void 0 : primaryAction.onAction);
  var onExecutedCancelAction = useCallback(function () {
    var _cancelAction$onActio;

    (_cancelAction$onActio = cancelAction.onAction) === null || _cancelAction$onActio === void 0 ? void 0 : _cancelAction$onActio.call(cancelAction);
    setMode(IndexFiltersMode.Default);
  }, [cancelAction, setMode]);
  var enhancedPrimaryAction = useMemo(function () {
    return primaryAction ? _objectSpread(_objectSpread({}, primaryAction), {}, {
      onAction: onExecutedPrimaryAction
    }) : undefined;
  }, [onExecutedPrimaryAction, primaryAction]);
  var enhancedCancelAction = useMemo(function () {
    return _objectSpread(_objectSpread({}, cancelAction), {}, {
      onAction: onExecutedCancelAction
    });
  }, [cancelAction, onExecutedCancelAction]);
  var beginEdit = useCallback(function () {
    setMode(IndexFiltersMode.Filtering);
    onEditStart === null || onEditStart === void 0 ? void 0 : onEditStart();
  }, [onEditStart, setMode]);
  var updateButtonsMarkup = useMemo(function () {
    return /*#__PURE__*/React.createElement(UpdateButtons, {
      primaryAction: enhancedPrimaryAction,
      cancelAction: enhancedCancelAction,
      viewNames: viewNames,
      disabled: disabled
    });
  }, [enhancedPrimaryAction, enhancedCancelAction, disabled, viewNames]);
  var sortMarkup = useMemo(function () {
    if (!(sortOptions !== null && sortOptions !== void 0 && sortOptions.length)) {
      return null;
    }

    return /*#__PURE__*/React.createElement(SortButton, {
      choices: sortOptions,
      selected: sortSelected,
      onChange: handleChangeSortButton,
      onChangeKey: onSortKeyChange,
      onChangeDirection: onSortDirectionChange,
      disabled: disabled
    });
  }, [handleChangeSortButton, onSortDirectionChange, onSortKeyChange, sortOptions, sortSelected, disabled]);
  var isActionLoading = (primaryAction === null || primaryAction === void 0 ? void 0 : primaryAction.loading) || (cancelAction === null || cancelAction === void 0 ? void 0 : cancelAction.loading);

  function handleClickFilterButton() {
    beginEdit();
  }

  var searchFilterTooltip = filteringAccessibilityTooltip || i18n.translate('Polaris.IndexFilters.searchFilterTooltip');
  var searchFilterAriaLabel = filteringAccessibilityLabel || i18n.translate('Polaris.IndexFilters.searchFilterAccessibilityLabel');
  var isLoading = loading || isActionLoading;

  function onPressEscape() {
    cancelAction === null || cancelAction === void 0 ? void 0 : cancelAction.onAction();
    setMode(IndexFiltersMode.Default);
  }

  function handleClearSearch() {
    onQueryClear === null || onQueryClear === void 0 ? void 0 : onQueryClear();
  }

  function handleQueryBlur() {
    setFiltersUnFocused();
  }

  function handleQueryFocus() {
    setFiltersFocused();
    onQueryFocus === null || onQueryFocus === void 0 ? void 0 : onQueryFocus();
  }

  function onPressF() {
    if (mode !== IndexFiltersMode.Default) {
      return;
    }

    beginEdit();
  }

  return /*#__PURE__*/React.createElement("div", {
    className: styles.IndexFiltersWrapper,
    style: {
      height: indexFilteringHeight
    }
  }, /*#__PURE__*/React.createElement("div", {
    ref: intersectionRef
  }), /*#__PURE__*/React.createElement("div", {
    className: classNames(styles.IndexFilters, isSticky && styles.IndexFiltersSticky, isSticky && isFlushWhenSticky && styles.IndexFiltersStickyFlush),
    ref: measurerRef
  }, /*#__PURE__*/React.createElement(Transition, {
    nodeRef: defaultRef,
    in: mode !== IndexFiltersMode.Filtering,
    timeout: TRANSITION_DURATION
  }, function (state) {
    return /*#__PURE__*/React.createElement("div", {
      ref: defaultRef
    }, mode !== IndexFiltersMode.Filtering ? /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(HorizontalStack, {
      align: "start",
      blockAlign: "center",
      gap: {
        xs: '0',
        md: '2'
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: classNames(styles.TabsWrapper, mdDown && styles.SmallScreenTabsWrapper, isLoading && styles.TabsWrapperLoading)
    }, /*#__PURE__*/React.createElement("div", {
      className: styles.TabsInner,
      style: _objectSpread(_objectSpread({}, defaultStyle), transitionStyles[state])
    }, /*#__PURE__*/React.createElement(AlphaTabs, {
      tabs: tabs,
      selected: selected,
      onSelect: onSelect,
      disabled: Boolean(mode !== IndexFiltersMode.Default || disabled),
      canCreateNewView: canCreateNewView,
      onCreateNewView: onCreateNewView
    })), isLoading && mdDown && /*#__PURE__*/React.createElement("div", {
      className: styles.TabsLoading
    }, /*#__PURE__*/React.createElement(Spinner, {
      size: "small"
    }))), /*#__PURE__*/React.createElement("div", {
      className: styles.ActionWrap
    }, isLoading && !mdDown && /*#__PURE__*/React.createElement(Spinner, {
      size: "small"
    }), mode === IndexFiltersMode.Default ? /*#__PURE__*/React.createElement(React.Fragment, null, hideFilters && hideQueryField ? null : /*#__PURE__*/React.createElement(SearchFilterButton, {
      onClick: handleClickFilterButton,
      "aria-label": searchFilterAriaLabel,
      tooltipContent: searchFilterTooltip,
      disabled: disabled,
      hideFilters: hideFilters,
      hideQueryField: hideQueryField,
      style: _objectSpread(_objectSpread({}, defaultStyle), transitionStyles[state])
    }), sortMarkup) : null, mode === IndexFiltersMode.EditingColumns ? updateButtonsMarkup : null))) : null);
  }), /*#__PURE__*/React.createElement(Transition, {
    nodeRef: filteringRef,
    in: mode === IndexFiltersMode.Filtering,
    timeout: TRANSITION_DURATION
  }, function (state) {
    return /*#__PURE__*/React.createElement("div", {
      ref: filteringRef
    }, mode === IndexFiltersMode.Filtering ? /*#__PURE__*/React.createElement(AlphaFilters, {
      queryValue: queryValue,
      queryPlaceholder: queryPlaceholder,
      onQueryChange: handleChangeSearch,
      onQueryClear: handleClearSearch,
      onQueryFocus: handleQueryFocus,
      onQueryBlur: handleQueryBlur,
      filters: filters,
      appliedFilters: appliedFilters,
      onClearAll: onClearAll,
      disableFilters: disabled,
      hideFilters: hideFilters,
      hideQueryField: hideQueryField,
      disableQueryField: disabled || disableQueryField,
      loading: loading || isActionLoading,
      focused: filtersFocused,
      mountedState: mdDown ? undefined : state,
      borderlessQueryField: true
    }, /*#__PURE__*/React.createElement(HorizontalStack, {
      gap: "3",
      align: "start",
      blockAlign: "center"
    }, /*#__PURE__*/React.createElement("div", {
      style: _objectSpread(_objectSpread({}, defaultStyle), transitionStyles[state])
    }, updateButtonsMarkup), sortMarkup)) : null);
  })));
}

export { IndexFilters };